<script setup lang="ts">
const { t } = useI18n()
const show = ref(false)
const domain = ref()
useLockAppScrollWhenVisible(show)

const openModal = (currentDomain?: string) => {
  show.value = true
  domain.value = currentDomain
}
const close = () => {
  show.value = false
}
defineExpose({
  openModal,
  close,
})
</script>

<template>
  <div v-if="!isMobile()">
    <n-modal v-model:show="show" transform-origin="center" :mask-closable="true">
      <LoginInfo is-modal :domain="domain" @close="close" />
    </n-modal>
  </div>
  <div v-else>
    <n-modal v-model:show="show" transform-origin="center" :mask-closable="true">
      <div class="w-11/12 md:w-105">
        <div class="modal-content sm:p-6 p-4">
          <div class="text-4.75 leading-6 typeface-robotoMedium flex justify-between items-center">
            {{ t('Global.HiWelcome') }} 👋

            <div i-ph:x-bold class="w-5 h-5 cursor-pointer -mr-2" @click="show = false" />
          </div>
          <div class="text-sm text-brandB">
            {{ t('Global.loginDesc') }}
          </div>
          <SigninAndSignup is-modal />
        </div>
      </div>
    </n-modal>
  </div>
</template>
